export default {
  namespaced: true,
  state: {
    gamesList: [],
    actualGamesCount: 0,
  },
  actions: {
    GetGamesList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'actualGamesCount', value: 0 });
      commit('setField', { name: 'gamesList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('tasks/api/task/history-list', payload)
          .then((response) => {
            if (response && response.data) {
              const actualGamesCount = response.data.tasks.filter(item => item.is_actual);
              commit('setField', { name: 'actualGamesCount', value: actualGamesCount.length });
              commit('setField', { name: 'gamesList', value: response.data.tasks });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreGames({ commit }) {
      commit('setField', { name: 'actualGamesCount', value: 0 });
      commit('setField', { name: 'gamesList', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
